'use client'

import React, { useState } from 'react'
import styles from './styles.module.css'
import Img from '../../Img'
import HighlightedText from '../../Utils/HighlightedText'
import CtaV2 from '../../CtaV2'
import Text from '../../Text'
import { $textPrimary } from '../../../styles/colors/semantics'
import CheckmarkIcon from '../../icons/CheckmarkIcon'
import featuresStyles from '../Products/FeaturesOverview/styles.module.css'
import { getFlexBasis } from '../../../styles/cssUtils'
import { $white } from '../../../styles/colors/primitives'
// ChristmasLights is a ~220 KB inline SVG (embedded base64) used only on the
// seasonal Black-Friday surfaces. It was code-split (task #67) to keep its weight
// out of the year-round shared bundle — but it is rendered UNCONDITIONALLY in this
// hero, so under App-Router SSR streaming a `next/dynamic` here emits a pending
// streaming-Suspense boundary that reorders the footer (the #130 / React #418/#422
// class) now that this page renders on the RSC server path (#118 slice 7). Static
// import instead: BF2024Hero is itself an ISLAND loaded ONLY on /holiday-sale-2025,
// so the SVG now lives in this island's own chunk — zero cost to year-round
// visitors, and NO streaming-Suspense boundary. (Same discipline as #134.)
import ChristmasLights from '../../icons/ChristmasLights'

function BF2024Hero({ titleHl, subtitleHl, textHl, imageCs, imageCs_2, ctaV2, isCompact,
                      card1_titleHl, card1_subtitleHl, card1_textHl, card1_imageCs,
                      card2_titleHl, card2_subtitleHl, card2_textHl, card2_imageCs,
                      card3_titleHl, card3_subtitleHl, card3_textHl, card3_imageCs,
                      card1_content, card2_content, card3_content,
                      card3_features
                    }) {
  const [showCard1PopUp, setShowCard1PopUp] = useState(false)
  const [showCard2PopUp, setShowCard2PopUp] = useState(false)
  const [showCard3PopUp, setShowCard3PopUp] = useState(false)

  if (isCompact) {
    // task #67: styled bg fed the resolved descriptor url (imageCs.image.src)
    return (
      <div className={styles.blackFridayHeader} style={{ backgroundImage: `url(${imageCs?.image?.src})` }}>
        <div className="flex flex-col g-2 items-center justify-center text-center">
          {/* Single-<h1> rule (Audit A #1): seasonal /holiday-sale-2025 hero title
              is the page's one visible <h1>. `primary` keeps the heading-2 variant
              visual class, only the tag becomes <h1>. */}
          <Text type="heading-2" color={$textPrimary.dark} primary>Holiday Sale 2025</Text>
          <HighlightedText {...subtitleHl}/>
        </div>
        <div className="lg:max-w-1/3 md:max-w-1/2 text-center">
          <Text type="large" color={$textPrimary.dark}>{'Holiday sales are here - enjoy great discounts across our store while stocks last. Hurry, limited-stock deals won’t be around for long!'}</Text>
        </div>
      </div>
    )
  } else {
    return (
      <div className="flex items-center justify-center">
        <div className={styles.contentWrapper}>
          <div className="z-0 absolute md:block hidden">
            <ChristmasLights/>
          </div>
          {/* task #67: styled bg fed the resolved descriptor url */}
          <div className={styles.blackFridayHeader} style={{ backgroundImage: `url(${imageCs?.image?.src})` }}>
            <div className="flex lg:flex-row flex-col items-center justify-center text-center">
              <div className="flex flex-col lg:w-1/3 w-full gap-8 items-center justify-center text-center z-1">
                <div className="flex flex-col w-full gap-2 text-center lg:text-left">
                  {/* Single-<h1> rule (Audit A #1): non-compact hero title (the
                      variant /holiday-sale-2025 actually renders) is the page's one
                      visible <h1>. `.h1-contents` adds no box. */}
                  <h1 className="h1-contents"><HighlightedText {...titleHl}/></h1>
                  <HighlightedText {...subtitleHl}/>
                </div>
                <div className="w-full lg:text-left">
                  <HighlightedText {...textHl}/>
                </div>
                { ctaV2 && <CtaV2 {...ctaV2} sx={{ width: '100%', height: '80px', titleTextType: 'heading-5' }} />}
              </div>
              <div className="lg:h-[700px] h-full">
                {/* task #67: render resolved descriptor via <Img> */}
                <Img image={imageCs_2.image} objectFit="contain" alt={imageCs_2.alt} />
              </div>
            </div>
          </div>
          {/*<div className="mt-4">*/}
          {/*  {*/}
          {/*    !!card3_titleHl && <CardWrapper>*/}
          {/*      <div className="flex md:w-full lg:w-1/2 w-full">*/}
          {/*        <div className="flex flex-col w-full gap-8 items-center justify-center text-center">*/}
          {/*          <div className="w-[160px]">*/}
          {/*            <ProgressiveImage*/}
          {/*              src={getImageSrc(card3_imageCs.image)}*/}
          {/*              placeholderSrc={getImagePlaceholderSrc(card3_imageCs.image)}*/}
          {/*              alt={card3_imageCs.alt}*/}
          {/*            />*/}
          {/*          </div>*/}
          {/*          <div className="flex flex-col lg:w-1/2 gap-2 items-center justify-center text-center">*/}
          {/*            <HighlightedText {...card3_titleHl}/>*/}
          {/*            <HighlightedText {...card3_subtitleHl}/>*/}
          {/*          </div>*/}
          {/*          <div className="lg:w-1/2">*/}
          {/*            <HighlightedText {...card3_textHl}/>*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*      <div className="lg:w-4/5 w-full mt-4 mb-6">*/}
          {/*        { renderSpecsList(card3_features, 3) }*/}
          {/*      </div>*/}
          {/*    </CardWrapper>*/}
          {/*  }*/}
          {/*</div>*/}
      {/*    <div className="md:flex-row flex-col flex gap-4 mt-4">*/}
      {/*      {*/}
      {/*        card1_titleHl && <CardWrapper>*/}
      {/*          <div className="flex md:w-full lg:w-1/2 w-full">*/}
      {/*            <div className="flex flex-col w-full gap-8 items-center justify-center text-center">*/}
      {/*              <div className="flex flex-col w-full gap-2 items-center justify-center text-center">*/}
      {/*                <HighlightedText {...card1_titleHl}/>*/}
      {/*                <HighlightedText {...card1_subtitleHl}/>*/}
      {/*              </div>*/}
      {/*              <div className="w-[160px]">*/}
      {/*                <ProgressiveImage*/}
      {/*                  src={getImageSrc(card1_imageCs.image)}*/}
      {/*                  placeholderSrc={getImagePlaceholderSrc(card1_imageCs.image)}*/}
      {/*                  alt={card1_imageCs.alt}*/}
      {/*                />*/}
      {/*              </div>*/}
      {/*              <HighlightedText {...card1_textHl}/>*/}
      {/*              <CtaV2 title="Learn more" transparent onClick={() => setShowCard1PopUp(true) }/>*/}
      {/*            </div>*/}
      {/*          </div>*/}
      {/*        </CardWrapper>*/}
      {/*      }*/}
      {/*      {*/}
      {/*        card2_subtitleHl && <CardWrapper>*/}
      {/*          <div className="flex md:w-full lg:w-1/2 w-full">*/}
      {/*            <div className="flex flex-col w-full gap-8 items-center justify-center text-center">*/}
      {/*              <div className="flex flex-col w-full gap-2 items-center justify-center text-center">*/}
      {/*                <HighlightedText {...card2_titleHl}/>*/}
      {/*                <HighlightedText {...card2_subtitleHl}/>*/}
      {/*              </div>*/}
      {/*              <div className="w-[160px]">*/}
      {/*                <ProgressiveImage*/}
      {/*                  src={getImageSrc(card2_imageCs.image)}*/}
      {/*                  placeholderSrc={getImagePlaceholderSrc(card2_imageCs.image)}*/}
      {/*                  alt={card2_imageCs.alt}*/}
      {/*                />*/}
      {/*              </div>*/}
      {/*              <HighlightedText {...card2_textHl}/>*/}
      {/*              <CtaV2 title="Learn more" transparent onClick={() => setShowCard2PopUp(true) }/>*/}
      {/*            </div>*/}
      {/*          </div>*/}
      {/*        </CardWrapper>*/}
      {/*      }*/}

      {/*      <Backdrop show={showCard1PopUp || showCard2PopUp || showCard3PopUp} onClick={() => {*/}
      {/*        setShowCard1PopUp(false)*/}
      {/*        setShowCard2PopUp(false)*/}
      {/*        setShowCard3PopUp(false)*/}
      {/*      }}/>*/}
      {/*      <PopUp show={showCard1PopUp}>*/}
      {/*        <CloseIconWrapper onClick={() => setShowCard1PopUp(false)}>*/}
      {/*          <CloseIcon/>*/}
      {/*        </CloseIconWrapper>*/}
      {/*        <HighlightedText {...card1_content} applySpace/>*/}
      {/*      </PopUp>*/}
      {/*      <PopUp show={showCard2PopUp}>*/}
      {/*        <CloseIconWrapper onClick={() => setShowCard2PopUp(false)}>*/}
      {/*          <CloseIcon/>*/}
      {/*        </CloseIconWrapper>*/}
      {/*        <HighlightedText {...card2_content} applySpace/>*/}
      {/*      </PopUp>*/}
      {/*    </div>*/}

        </div>
      </div>
    )
  }

}

const renderSpecsList = (specs, specsOnRow) => {
  if (!specs) return null

  return (
    <div className={featuresStyles.specsWrapper}>
      <div className={featuresStyles.specsRow}>
        { specs.map(spec => renderSingleSpec(spec, specsOnRow))}
      </div>
    </div>
  )
}

// specsOnRow={{ forDesktop: 3 }}, hasTitle=false, hasSubtitle=true — the same
// flex-basis custom properties FeaturesOverview computes (SPECS_GAP = 8px). With
// hasTitle=false no .specHasTitle*/padding modifiers apply, so the base .spec
// (row, 32px padding) matches the former styled output exactly.
const SPECS_GAP = '8px'

const renderSingleSpec = (title, specsOnRow) => {
  const specStyle = {
    '--spec-basis-desktop': getFlexBasis(3, SPECS_GAP),
    '--spec-basis-tablet': getFlexBasis(3, SPECS_GAP),
    '--spec-basis-mobile': getFlexBasis(2, SPECS_GAP),
  }
  return (
    <div className={`${featuresStyles.spec} items-center lg:py-[32px] px-[16px]`} style={specStyle}>
      <div>
        <CheckmarkIcon color={$white}/>
      </div>
      <div className={featuresStyles.specText}>
        <div className={featuresStyles.specTitle}>
          <Text type="large">{title}</Text>
        </div>
      </div>
    </div>
  )
}

export default BF2024Hero
